import React from 'react';
import { useAddEpicMutation } from '@/redux';
import { useAppFindFormik } from '@/components';
import { AddEpicDto, ProjectDto } from '@/core';
import { EpicForm } from './EpicForm';
import { FormValueType } from './hooks';

const getInitialValue = (): FormValueType => ({
  name: '',
  description: '',
});

type PropsType = {
  projectData: ProjectDto;
};

export const ProjectsAddEpicForm = ({ projectData }: PropsType) => {
  const form = useAppFindFormik('add-epic');
  const [addEpic] = useAddEpicMutation();
  const initialValue = getInitialValue();

  const handleSubmit = (epicData: AddEpicDto) => {
    addEpic({ epicData, projectId: projectData.id })
      .unwrap()
      .then(() => form.current?.resetForm());
  };

  return (
    <EpicForm
      handleSubmit={handleSubmit}
      formUid="add-epic"
      initialValue={initialValue}
      projectData={projectData}
      isTooltip
    />
  );
};
